'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_table$package$$anon$6(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_table$package$$anon$6 as $c_Lpresto_table$package$$anon$6 };
$p = $c_Lpresto_table$package$$anon$6.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_table$package$$anon$6;
/** @constructor */
function $h_Lpresto_table$package$$anon$6() {
}
export { $h_Lpresto_table$package$$anon$6 as $h_Lpresto_table$package$$anon$6 };
$h_Lpresto_table$package$$anon$6.prototype = $p;
var $d_Lpresto_table$package$$anon$6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_table$package$$anon$6, "presto.table$package$$anon$6", ({
  Y8: 1,
  MD: 1
}));
export { $d_Lpresto_table$package$$anon$6 as $d_Lpresto_table$package$$anon$6 };
//# sourceMappingURL=presto.table$package$$anon$6.js.map
